/**
 * Screening status enums matching backend DataTypes.
 * Use these to map API values to display labels.
 */

// Voice/call screening: 0:pending, 1:calling, 2:completed, 3:failed
export const CALL_STATUS = {
  PENDING: '0',
  CALLING: '1',
  COMPLETED: '2',
  FAILED: '3',
};

export const CALL_STATUS_LABELS = {
  '0': 'Pending',
  '1': 'Calling',
  '2': 'Completed',
  '3': 'Failed',
};

// Document verification_status: 0:pending, 1:verified, 2:rejected
// reference_check_status: same
export const VERIFICATION_STATUS = {
  PENDING: '0',
  VERIFIED: '1',
  REJECTED: '2',
};

export const VERIFICATION_STATUS_LABELS = {
  '0': 'Pending',
  '1': 'Verified',
  '2': 'Rejected',
};

// Final screening property_tenant_status: 0:pending, 1:verified, 2:rejected
export const PROPERTY_TENANT_STATUS = {
  PENDING: '0',
  VERIFIED: '1',
  REJECTED: '2',
};

export const PROPERTY_TENANT_STATUS_LABELS = {
  '0': 'Pending',
  '1': 'Verified',
  '2': 'Rejected',
};

/** Normalize value to string for lookup (API may send number or string) */
export const toStatusKey = (v) => (v == null ? '0' : String(v));

export const getCallStatusLabel = (value) =>
  CALL_STATUS_LABELS[toStatusKey(value)] ?? 'Pending';

export const getVerificationStatusLabel = (value) =>
  VERIFICATION_STATUS_LABELS[toStatusKey(value)] ?? 'Pending';

export const getPropertyTenantStatusLabel = (value) =>
  PROPERTY_TENANT_STATUS_LABELS[toStatusKey(value)] ?? 'Pending';
